var _path, _path2, _rect, _ellipse, _path3, _path4, _rect2, _ellipse2, _path5, _path6, _path7, _path8, _path9, _path10, _rect3, _ellipse3, _path11, _path12, _rect4, _ellipse4, _path13, _path14, _rect5, _ellipse5, _path15, _path16, _path17, _path18, _path19, _path20, _rect6, _ellipse6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountPendingDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 105,
    viewBox: "0 0 114 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.658 98.127a.541.541 0 0 1 .01-.93l51.584-30.086 9.91 6.653a.541.541 0 0 1-.021.913l-49.396 29.81a1.623 1.623 0 0 1-1.685-.004l-10.402-6.356z",
    fill: "#0C141A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 64.306c-2.228 3.9-5.429 6.727-8.791 8.153-3.362 1.426-6.87 1.446-9.748-.233-2.879-1.68-4.616-4.761-5.076-8.419-.46-3.657.364-7.873 2.592-11.772 2.228-3.9 5.428-6.727 8.79-8.153 3.363-1.425 6.87-1.446 9.749.233 2.878 1.68 4.616 4.761 5.075 8.419.46 3.657-.363 7.873-2.591 11.772z",
    fill: "#0E1D31",
    stroke: "#0E1D31",
    strokeWidth: 0.541
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.342,
    y: 49.83,
    width: 3.856,
    height: 11.546,
    rx: 1.928,
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.27,
    cy: 65.012,
    rx: 1.928,
    ry: 1.924,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.658 98.127a.541.541 0 0 1 .01-.93l51.584-30.086 9.91 6.653a.541.541 0 0 1-.021.913l-49.396 29.81a1.623 1.623 0 0 1-1.685-.004l-10.402-6.356z",
    fill: "#0C141A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 64.306c-2.228 3.9-5.429 6.727-8.791 8.153-3.362 1.426-6.87 1.446-9.748-.233-2.879-1.68-4.616-4.761-5.076-8.419-.46-3.657.364-7.873 2.592-11.772 2.228-3.9 5.428-6.727 8.79-8.153 3.363-1.425 6.87-1.446 9.749.233 2.878 1.68 4.616 4.761 5.075 8.419.46 3.657-.363 7.873-2.591 11.772z",
    fill: "#0E1D31",
    stroke: "#0E1D31",
    strokeWidth: 0.541
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.342,
    y: 49.83,
    width: 3.856,
    height: 11.546,
    rx: 1.928,
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.27,
    cy: 65.012,
    rx: 1.928,
    ry: 1.924,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.658 98.127a.541.541 0 0 1 .01-.93l51.584-30.086 9.91 6.653a.541.541 0 0 1-.021.913l-49.396 29.81a1.623 1.623 0 0 1-1.685-.004l-10.402-6.356z",
    fill: "#0C141A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.98 42.768c-4.682-2.692-10.882-1.946-17.198 1.635-6.304 3.573-12.623 9.924-17.434 18.219-6.907 11.911-8.886 24.481-6.97 32.765l.005.005.037.038.052.048.064.055.124.1.151.113.177.127.201.138.006.005.143.095.005.004.242.157.005.003.266.17.005.003.396.245.005.003.44.267.004.002.614.364.004.002.54.314.003.002.738.422.003.002.639.36.002.001.683.381.002.002 1.5.825.002.001 1.673.907.002.001 1.297.694.31-.243v-.001l1.165-.92 30.098-57.31zm0 0 .205.117v.001l1.44.831.003.002.623.364.003.002.632.375.003.002.426.255.003.002.652.398.003.002.441.273.003.002.448.282.004.003.69.442.004.003.47.306.003.003.48.318.003.003.491.33.003.003.504.345.001.001.255.177h.001l.522.367.004.003.533.38.004.003.547.397.003.002.562.414.003.002.37.277c.029 2.511-.893 5.539-2.425 8.781-1.579 3.34-3.78 6.854-6.158 10.178l-.477.662-.001.001-.239.327-.483.653c-.162.217-.323.432-.485.645l-.487.638-.001.001-.243.315-.488.626-.243.308h-.001l-.487.612h-.001c-.08.101-.161.201-.242.3v.002l-.484.594-.002.003-.481.583-.24.287-.475.566-.002.002-.47.551-.002.003-.464.539h-.001m4.74-33.864-4.74 33.865M23.262 95.49l-.038.009m.038-.009-.038.009m.038-.009.047-.011-.047.011zm-.038.009.116-.086-.116.086zm34.18-15.731c-6.142 6.495-13.648 13.266-22.52 20.31l22.52-20.31zm0 0 .002-.001.408-.435.002-.002.42-.453.213-.233.435-.479.002-.002.443-.495a91.213 91.213 0 0 0 .225-.253l.456-.519-2.605 2.872zm2.836-3.135-.229.262.229-.262z",
    fill: "#57A593",
    stroke: "#0E1D31",
    strokeWidth: 1.082
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m79.167 74.523-45.66 26.595c-3.458-8.07-1.739-21.054 5.407-33.377 4.81-8.295 11.13-14.646 17.434-18.219 6.316-3.58 12.516-4.326 17.199-1.635 3.47 1.995 5.71 5.642 6.659 10.35.938 4.654.603 10.306-1.039 16.286z",
    fill: "#A0C2C3",
    stroke: "#0E1D31",
    strokeWidth: 1.082
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m35.852 47.483-.002-.001a39.614 39.614 0 0 0-.46-.27c-3.531-2.029-5.4-6.352-5.432-11.87-.033-5.502 1.769-12.084 5.443-18.42C39.075 10.585 43.9 5.74 48.704 3.017 53.521.286 58.218-.265 61.749 1.765l.002.001.453.257.004.002.451.251.003.002 1.56.857.004.002.43.24.005.003.425.243h.001c1.503.872 2.827 1.781 3.83 2.992.992 1.2 1.69 2.72 1.89 4.851.408 4.31-1.216 11.096-6.6 22.592-5.312 11.345-9.975 16.114-14.029 17.626-4.01 1.496-7.601-.133-11.017-2.173h-.002l-.481-.291-.003-.002-.477-.293-.002-.001-1.415-.878-.003-.002-.463-.283-.004-.002-.459-.276z",
    fill: "#57A593",
    stroke: "#0E1D31",
    strokeWidth: 1.082
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.298 35.973c-3.675 6.336-8.499 11.181-13.303 13.905-4.818 2.73-9.514 3.282-13.045 1.252-3.53-2.03-5.399-6.352-5.432-11.87-.033-5.503 1.77-12.084 5.443-18.42 3.675-6.337 8.499-11.182 13.303-13.905 4.818-2.731 9.514-3.282 13.045-1.252 3.53 2.029 5.399 6.352 5.432 11.87.033 5.502-1.769 12.084-5.443 18.42z",
    fill: "#A0C2C3",
    stroke: "#0E1D31",
    strokeWidth: 1.082
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.15 64.192c-2.205 3.86-5.369 6.651-8.68 8.056-3.312 1.404-6.742 1.415-9.544-.22-2.803-1.636-4.51-4.645-4.963-8.25-.453-3.603.358-7.77 2.563-11.63 2.205-3.86 5.37-6.65 8.681-8.055 3.311-1.404 6.74-1.415 9.543.22 2.803 1.636 4.511 4.645 4.964 8.25.453 3.603-.358 7.77-2.563 11.63z",
    fill: "#0C141A",
    stroke: "#0E1D31"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.342,
    y: 49.83,
    width: 3.856,
    height: 11.546,
    rx: 1.928,
    fill: "#A0C2C3"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.27,
    cy: 65.012,
    rx: 1.928,
    ry: 1.924,
    fill: "#A0C2C3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.658 98.127a.541.541 0 0 1 .01-.93l51.584-30.086 9.91 6.653a.541.541 0 0 1-.021.913l-49.396 29.81a1.623 1.623 0 0 1-1.685-.004l-10.402-6.356z",
    fill: "#0C141A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 64.306c-2.228 3.9-5.429 6.727-8.791 8.153-3.362 1.426-6.87 1.446-9.748-.233-2.879-1.68-4.616-4.761-5.076-8.419-.46-3.657.364-7.873 2.592-11.772 2.228-3.9 5.428-6.727 8.79-8.153 3.363-1.425 6.87-1.446 9.749.233 2.878 1.68 4.616 4.761 5.075 8.419.46 3.657-.363 7.873-2.591 11.772z",
    fill: "#0E1D31",
    stroke: "#0E1D31",
    strokeWidth: 0.541
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.342,
    y: 49.83,
    width: 3.856,
    height: 11.546,
    rx: 1.928,
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.27,
    cy: 65.012,
    rx: 1.928,
    ry: 1.924,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.658 98.127a.541.541 0 0 1 .01-.93l51.584-30.086 9.91 6.653a.541.541 0 0 1-.021.913l-49.396 29.81a1.623 1.623 0 0 1-1.685-.004l-10.402-6.356z",
    fill: "#0C141A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 64.306c-2.228 3.9-5.429 6.727-8.791 8.153-3.362 1.426-6.87 1.446-9.748-.233-2.879-1.68-4.616-4.761-5.076-8.419-.46-3.657.364-7.873 2.592-11.772 2.228-3.9 5.428-6.727 8.79-8.153 3.363-1.425 6.87-1.446 9.749.233 2.878 1.68 4.616 4.761 5.075 8.419.46 3.657-.363 7.873-2.591 11.772z",
    fill: "#0E1D31",
    stroke: "#0E1D31",
    strokeWidth: 0.541
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.342,
    y: 49.83,
    width: 3.856,
    height: 11.546,
    rx: 1.928,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.27,
    cy: 65.012,
    rx: 1.928,
    ry: 1.924,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.658 98.127a.541.541 0 0 1 .01-.93l51.584-30.086 9.91 6.653a.541.541 0 0 1-.021.913l-49.396 29.81a1.623 1.623 0 0 1-1.685-.004l-10.402-6.356z",
    fill: "#0C141A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.98 42.768c-4.682-2.692-10.882-1.946-17.198 1.635-6.304 3.573-12.623 9.924-17.434 18.219-6.907 11.911-8.886 24.481-6.97 32.765l.005.005.037.038.052.048.064.055.124.1.151.113.177.127.201.138.006.005.143.095.005.004.242.157.005.003.266.17.005.003.396.245.005.003.44.267.004.002.614.364.004.002.54.314.003.002.738.422.003.002.639.36.002.001.683.381.002.002 1.5.825.002.001 1.673.907.002.001 1.297.694.31-.243v-.001l1.165-.92 30.098-57.31zm0 0 .205.117v.001l1.44.831.003.002.623.364.003.002.632.375.003.002.426.255.003.002.652.398.003.002.441.273.003.002.448.282.004.003.69.442.004.003.47.306.003.003.48.318.003.003.491.33.003.003.504.345.001.001.255.177h.001l.522.367.004.003.533.38.004.003.547.397.003.002.562.414.003.002.37.277c.029 2.511-.893 5.539-2.425 8.781-1.579 3.34-3.78 6.854-6.158 10.178l-.477.662-.001.001-.239.327-.483.653c-.162.217-.323.432-.485.645l-.487.638-.001.001-.243.315-.488.626-.243.308h-.001l-.487.612h-.001c-.08.101-.161.201-.242.3v.002l-.484.594-.002.003-.481.583-.24.287-.475.566-.002.002-.47.551-.002.003-.464.539h-.001m4.74-33.864-4.74 33.865M23.262 95.49l-.038.009m.038-.009-.038.009m.038-.009.047-.011-.047.011zm-.038.009.116-.086-.116.086zm34.18-15.731c-6.142 6.495-13.648 13.266-22.52 20.31l22.52-20.31zm0 0 .002-.001.408-.435.002-.002.42-.453.213-.233.435-.479.002-.002.443-.495a91.213 91.213 0 0 0 .225-.253l.456-.519-2.605 2.872zm2.836-3.135-.229.262.229-.262z",
    fill: "#2F353B",
    stroke: "#BFC1C2",
    strokeWidth: 1.082
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m79.167 74.523-45.66 26.595c-3.458-8.07-1.739-21.054 5.407-33.377 4.81-8.295 11.13-14.646 17.434-18.219 6.316-3.58 12.516-4.326 17.199-1.635 3.47 1.995 5.71 5.642 6.659 10.35.938 4.654.603 10.306-1.039 16.286z",
    fill: "#5D6266",
    stroke: "#BFC1C2",
    strokeWidth: 1.082
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m35.852 47.483-.002-.001a39.614 39.614 0 0 0-.46-.27c-3.531-2.029-5.4-6.352-5.432-11.87-.033-5.502 1.769-12.084 5.443-18.42C39.075 10.585 43.9 5.74 48.704 3.017 53.521.286 58.218-.265 61.749 1.765l.002.001.453.257.004.002.451.251.003.002 1.56.857.004.002.43.24.005.003.425.243h.001c1.503.872 2.827 1.781 3.83 2.992.992 1.2 1.69 2.72 1.89 4.851.408 4.31-1.216 11.096-6.6 22.592-5.312 11.345-9.975 16.114-14.029 17.626-4.01 1.496-7.601-.133-11.017-2.173h-.002l-.481-.291-.003-.002-.477-.293-.002-.001-1.415-.878-.003-.002-.463-.283-.004-.002-.459-.276z",
    fill: "#2F353B",
    stroke: "#BFC1C2",
    strokeWidth: 1.082
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.298 35.973c-3.675 6.336-8.499 11.181-13.303 13.905-4.818 2.73-9.514 3.282-13.045 1.252-3.53-2.03-5.399-6.352-5.432-11.87-.033-5.503 1.77-12.084 5.443-18.42 3.675-6.337 8.499-11.182 13.303-13.905 4.818-2.731 9.514-3.282 13.045-1.252 3.53 2.029 5.399 6.352 5.432 11.87.033 5.502-1.769 12.084-5.443 18.42z",
    fill: "#5D6266",
    stroke: "#BFC1C2",
    strokeWidth: 1.082
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.15 64.192c-2.205 3.86-5.369 6.651-8.68 8.056-3.312 1.404-6.742 1.415-9.544-.22-2.803-1.636-4.51-4.645-4.963-8.25-.453-3.603.358-7.77 2.563-11.63 2.205-3.86 5.37-6.65 8.681-8.055 3.311-1.404 6.74-1.415 9.543.22 2.803 1.636 4.511 4.645 4.964 8.25.453 3.603-.358 7.77-2.563 11.63z",
    fill: "#242A30",
    stroke: "#BFC1C2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.342,
    y: 49.83,
    width: 3.856,
    height: 11.546,
    rx: 1.928,
    fill: "#BFC1C2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.27,
    cy: 65.012,
    rx: 1.928,
    ry: 1.924,
    fill: "#BFC1C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPendingDark);
export default __webpack_public_path__ + "static/media/account-pending-dark.c481c1c5.svg";
export { ForwardRef as ReactComponent };